import React from "react";
import { Card, Placeholder, Nav, ListGroup, Badge, Container } from "react-bootstrap";
import { Entry, LeagueData, Standing } from "../types/leagueData";

export interface LeagueProps {
  data: LeagueData;
  
}

function LeagueLoading() {
  return (
    <Card>
      <Card.Header>
        <Placeholder as={Card.Title} animation="glow">
          <Placeholder xs={6} />
        </Placeholder>
      </Card.Header>
    </Card>
  )
}

export function League(props: LeagueProps) {
  const standings: {name: string, player_name: string, points: number, position: number}[] = [];

  const overallStandings = props.data.standings.filter((v) => v.phase_id === 1); // Only get the overall standings;

  overallStandings.forEach((v) => {
    const entry = props.data?.entries.find((e: Entry) => v.entry_id === e.id);
    if (entry === undefined) {
      return;
    }
    standings.push({name: entry?.name, player_name: entry?.player_name, points: v.points, position: v.position});
  })

  standings.sort((a, b) =>  b.points - a.points);

  return (
    <Container>
      <ListGroup as="ol" numbered>
        {standings.map((p) => {
        return <ListGroup.Item
          as="li"
          className="d-flex justify-content-between align-items-start"
          key={p.player_name}
        >
          <div className="ms-2 me-auto">
            <div className="fw-bold">{p.name}</div>
            {p.player_name}
          </div>
          <Badge bg="primary" pill>
            {p.points}
          </Badge>
        </ListGroup.Item>
        })}
      </ListGroup>
    </Container>
  )
}
